import React from 'react';
import { Alert } from 'antd';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const ServiceBookingEmptyAlert: React.FC = () => {
  const { t } = useTranslation('manage');

  return (
    <Alert
      type="warning"
      showIcon
      title={t('appointmentComponents.create.service.noServicesTitle')}
      description={
        <>
          {t('appointmentComponents.create.service.noServicesDescription')}{' '}
          <Link to="/manage/company-services">{t('appointmentComponents.create.service.noServicesLink')}</Link>
        </>
      }
    />
  );
};
